var $$ = $$ || {};

$$.RegistrationEvent = class RegistrationEvent {
    constructor (root, options = {}) {
        var defaultOptions = {};
        this.root = root;
        this.options = _.assign(defaultOptions, options);

        this._cacheNodes();
        this._bindEvents();
        this._ready();
    }

    _cacheNodes () {
        this.nodes = {
            phone: this.root.find('.phone'),
            scrollBottomButton: $('.js-scroll-bottom-registration')
        };
    }

    _bindEvents () {
        this.root.on('submit', (event) => {
            event.preventDefault();

            this.root.find(`input`).removeClass('error');

            $.ajax({
                url:     this.root.attr('action'),
                method:  this.root.attr('method'),
                data:    this.root.serialize(),
                success: (response) => {
                    if (response.success) {
                        $$.Noty[ 'successMessage' ](response.success);
                        this.root.trigger('registrationEventFormSubmit');

                        if (response.redirect) {
                            window.location = response.redirect;
                        }

                        this.root.hide();
                        this.nodes.scrollBottomButton.hide();
                    } else {
                        _.each(response.errors, (value, key) => {
                            this.root.find(`input[name="${key}"]`).addClass('error');
                            $$.Noty[ 'errorMessage' ](value, 4000);
                        });
                    }
                },
                dataType: 'json'
            });

        });

        this.nodes.phone.on('focusout', (event) => this._clearBrokenPhoneNumber(event));
    }

    _clearBrokenPhoneNumber (event) {
        if ( $(event.currentTarget).val().indexOf('_') > 0 ) {
            $(event.currentTarget).val('');
        }
    }

    _ready () {
        this.nodes.phone.each((index, element) => {
            var inputMask = new Inputmask('8 (999) 999-99-99');

            inputMask.mask(element);
        });
    }
};
